const noop = () => {};
const isNoop = fn => fn === noop;

export default noop;
export { isNoop };
